import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { CookieService, LoginService } from '@service';

@Injectable()
export class LoginAuthGuard implements CanActivate {
  constructor(
    private cookieService: CookieService,
    private loginService: LoginService,
  ) {}

  async canActivate(): Promise<boolean> {
    const hasSession = this.cookieService.getDesSession();

    if (!hasSession) {
      return true;
    } else {
      await lastValueFrom(this.loginService.handleLogin());
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get('redirect_url');
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return false;
      }
      return true;
    }
  }
}
